import { useDispatch } from 'react-redux';
import { fetchApplicationUnsignedDocumentsCount } from '~/store/covenants/thunks/applicationThunks.ts';
import { AppDispatch } from '~/store/store.ts';

type TUseApplicationUnsignedDocumentsCountParams = {
  contragentId: number;
};

export const useApplicationUnsignedDocumentsCount = ({
  contragentId,
}: TUseApplicationUnsignedDocumentsCountParams) => {
  const dispatch = useDispatch<AppDispatch>();

  const getUnsignedDocumentsCount = async (applicationId: string): Promise<number | null> => {
    if (!contragentId || !applicationId) {
      return null;
    }

    try {
      return await dispatch(
        fetchApplicationUnsignedDocumentsCount({
          contragentId,
          applicationId,
        })
      ).unwrap();
    } catch (error) {
      console.warn('Не вдалося отримати кількість непідписаних документів', error);
      return null;
    }
  };

  return { getUnsignedDocumentsCount };
};
